import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { isEqual } from 'lodash-es';

export enum StateIconRendererIconType {
    AngularMaterial = 0,
    SeSvg = 1,
    SeFont = 2,
}

interface IStateIconRendererConfig {
    icon: string;
    negate: boolean;
    tooltip?: string;
    iconType?: StateIconRendererIconType;
    fontSize?: string;
    field: string;
    color?: string;
}

type IStateIconRendererParams = ICellRendererParams & {
    estensa: IStateIconRendererConfig[] | ((data: any) => IStateIconRendererConfig);
};

@Component({
    selector: 'se-state-icon-renderer',
    templateUrl: './state-icon-renderer.component.html',
    styleUrls: ['./state-icon-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StateIconRendererComponent implements ICellRendererAngularComp {
    config: IStateIconRendererConfig;
    isActive = false;

    private getPropertyValue(obj1, dataToRetrieve) {
        return dataToRetrieve.split('.').reduce(function(o, k) {
            return o?.[k];
        }, obj1);
    }

    refresh(params: IStateIconRendererParams): boolean {
        const shouldRefresh = !isEqual(params.value, this.isActive) || !isEqual(params.estensa, this.config);
        if (!shouldRefresh) {
            return false;
        }
        // Questo rendere può essere utilizzato in due modi: specificando un array di icone che verranno testate una ad
        //   una, oppure specificando una funzione che, una volta chiamata con i dati della riga, ritorna un'icona da
        //   mostrare.
        if (typeof params.estensa === 'function') {
            this.config = params.estensa(params.value);
            this.isActive = !!this.config;
            return true;
        }

        for (const row of params.estensa) {
            if (this.getPropertyValue(params.value, row.field)) {
                this.isActive = true;
                this.config = row;
            }
            if (row.negate) {
                this.isActive = !this.isActive;
            }
        }
    }

    agInit(params: IStateIconRendererParams): void {
        this.refresh(params);
    }

    getFontSize() {
        if (this.config?.fontSize) {
            return `${this.config.fontSize} !important`;
        }

        return undefined;
    }

    getColorStyle() {
        if (this.config?.color) {
            return `${this.config.color}`;
        }
    }
}
